import { GlobalResponseObject } from "@schemax-whatsapp/shared-models/common";
import { AssociatesModel } from "./associates.model";

export class AssociatesResponse extends GlobalResponseObject {
    data?: AssociatesModel[];
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: AssociatesModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}